module.exports = __webpack_public_path__ + "img/siakad.dd75faa8.svg";